var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodePlaceHolderFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 451,
    viewBox: "0 0 347 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289 19.0919H327.184V57.2756",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289 335.184H327.184V297",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2755 19.0919H19.0917V57.2756",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2755 335.184H19.0917V297",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.1507,
    y: 61.741,
    width: 85.3377,
    height: 85.3377,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8552,
    y: 85.4461,
    width: 37.9279,
    height: 37.9279,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184.675,
    y: 61.741,
    width: 85.3377,
    height: 85.3377,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.38,
    y: 85.4461,
    width: 37.9279,
    height: 37.9279,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1507,
    y: 194.489,
    width: 85.3377,
    height: 85.3377,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8552,
    y: 218.194,
    width: 37.9279,
    height: 37.9279,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 208.38,
    y: 218.194,
    width: 37.9279,
    height: 37.9279,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 255.79,
    y: 199.23,
    width: 9.48197,
    height: 9.48197,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 189.416,
    y: 199.23,
    width: 9.48197,
    height: 9.48197,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 189.416,
    y: 265.603,
    width: 9.48197,
    height: 9.48197,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 255.79,
    y: 265.603,
    width: 9.48197,
    height: 9.48197,
    stroke: "#565656",
    strokeWidth: 9.48197
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.145 289.585L121.077 313.597C116.866 314.909 112.447 312.589 111.135 308.378L105.362 289.848C104.05 285.637 106.369 281.218 110.58 279.906L187.648 255.894C191.86 254.582 196.278 256.901 197.591 261.113L203.364 279.643C204.545 283.433 202.357 288.273 198.145 289.585Z",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.43 388.41C172.954 392.609 158.593 385.071 154.394 371.595L134.975 309.267L183.405 294.177L202.824 356.505C207.444 369.851 199.906 384.212 186.43 388.41Z",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.198 374.711L253.296 386.52C244.873 389.144 240.234 397.982 242.858 406.404C245.483 414.827 240.844 423.665 232.421 426.289L216.839 431.144C208.416 433.768 199.579 429.129 196.955 420.706L186.72 387.858",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.305 320.607L170.422 337.032",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.342 212.523L136.886 187.29L162.11 135.832L139.523 124.757L114.296 176.214L62.8386 150.986L51.7645 173.575L103.224 198.804L77.9889 250.269L100.575 261.342L125.81 209.876L177.269 235.11L188.342 212.523Z",
    fill: "#BA2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodePlaceHolderFailed);
export default __webpack_public_path__ + "static/media/qr-code-place-holder-failed.c4a70ca06109c4853809cd3191d3239a.svg";
export { ForwardRef as ReactComponent };